// extracted by css-extract-rspack-plugin
export default {"list":"list-ej5ygS","item":"item-NA5sF8"};